import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ZefForm, ZefFormsManagerService } from '@zerops/zef/forms';
import { AppState } from '@zerops/zerops/app';
import { validate, FormState } from 'ngrx-forms';
import { maxLength, pattern, required } from 'ngrx-forms/validation';
import { FEATURE_NAME } from './common-standard-service-stack-form.constant';

export interface CommonStandardServiceStackFormValue {
  name: string;
  mode: 'HA' | 'NON_HA';
  customAutoscaling?: {
    horizontalAutoscaling?: {
      minContainerCount: number;
      maxContainerCount: number;
    };
    verticalAutoscaling?: {
      cpuMode: 'SHARED' | 'DEDICATED';
      startCpuCoreCount?: number;
      minFreeResource?: {
        cpuCoreCount?: number;
        cpuCorePercent?: number;
        memoryGBytes?: number;
        memoryPercent?: number;
      };
      maxResource: {
        cpuCoreCount: number;
        diskGBytes: number;
        memoryGBytes: number;
      };
      minResource: {
        cpuCoreCount: number;
        diskGBytes: number;
        memoryGBytes: number;
      };
    };
  }
}

export type CommonStandardServiceStackFormState = FormState<CommonStandardServiceStackFormValue>;

@Injectable({ providedIn: 'root' })
export class CommonStandardServiceStackForm extends ZefForm<CommonStandardServiceStackFormValue> {
  constructor(
    public store: Store<AppState>,
    public formsManager: ZefFormsManagerService
  ) {
    super(
      store,
      formsManager,
      FEATURE_NAME,
      {
        name: '',
        mode: 'HA',
        customAutoscaling: {}
      },
      {
        name: validate(required, maxLength(25), pattern(/^[a-z0-9]*$/))
      }
    );
  }
}
